import { Component } from '@angular/core';

@Component({
  selector: 'sui-loader',
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.scss',
})
export class LoaderComponent {}
